import { useCallback, useMemo } from 'react'

import { fetchExternalFile, fetchExternalThumbnail, streamExternalMusicDownload } from '@/api/api'
import type { ExternalMusicDownloadCompleted } from '@/api/type'
import type { ExternalDownloadConfig } from '@/hooks/useExternalDownload'
import { useExternalDownload } from '@/hooks/useExternalDownload'
import { db } from '@/lib/db'

export const useExternalMusicDownload = () => {
  const config = useMemo<ExternalDownloadConfig<ExternalMusicDownloadCompleted>>(
    () => ({
      mediaLabel: '音声',
      fetchFile: fetchExternalFile,
      fetchThumbnail: fetchExternalThumbnail,
      saveToDb: async ({ id, mediaBlob, thumbnailBlob, data, url }) => {
        const allMusic = await db.externalMusic.toArray()
        const maxOrder = allMusic.length > 0 ? Math.max(...allMusic.map((m) => m.order)) : -1

        await db.externalMusic.add({
          id,
          title: data.title,
          artist: data.artist,
          audioBlob: mediaBlob,
          thumbnailBlob,
          originalUrl: url,
          savedAt: Date.now(),
          fileSize: mediaBlob.size,
          duration: data.duration,
          order: maxOrder + 1,
        })
      },
    }),
    [],
  )

  const { downloadState, startDownload, cancelDownload } = useExternalDownload(config)

  const downloadMusic = useCallback(
    (url: string) => {
      startDownload(url, (onMessage, onError, signal) => {
        void streamExternalMusicDownload(url, onMessage, onError, signal)
      })
    },
    [startDownload],
  )

  return { downloadState, downloadMusic, cancelDownload }
}
